import React, { Fragment } from 'react';
import Container from '../../../../../../components/container';
import { H3, Cols } from '../../../../components';

const ITEMS = [
  {
    imageSrc: process.env.NEXT_PUBLIC_PUBLIC_URL + "/img/cours/private/student-item-1.png",
    title: "FLEXIBILTÉ",
    titleColor: "red",
    description: <Fragment>
      Des cours <b>proches de chez toi</b> aux horaires que tu souhaites.
    </Fragment>
  },

  {
    imageSrc: process.env.NEXT_PUBLIC_PUBLIC_URL + "/img/cours/private/student-item-2.png",
    title: <Fragment>REVENUS ÉLEVÉS<br/>ET RAPIDES</Fragment>,
    titleColor: "blue",
    description: <Fragment>
      <b>26€/heure brut</b><br/>
      jusqu’au bac, puis<br/>
      <b>38€/heure brut.</b><br/><br/>

      Paiement sous 48h.
    </Fragment>
  },

  {
    imageSrc: process.env.NEXT_PUBLIC_PUBLIC_URL + "/img/cours/private/student-item-3.png",
    title: "BOOSTER LE CV",
    titleColor: "red",
    description: <Fragment>
      Profite de <b>la certification Clevermate</b> et d’une <b>expérience valorisante</b> sur ton CV.
    </Fragment>
  },

  {
    imageSrc: process.env.NEXT_PUBLIC_PUBLIC_URL + "/img/cours/private/student-item-4.png",
    title: "JAMAIS SEUL.E",
    titleColor: "blue",
    description: <Fragment>
      <b>Une difficulté avec</b> un élève, <b>un doute</b> ?
      Notre ambassadeur des étudiants et son équipe sont <b>toujours là pour toi</b>.
    </Fragment>
  }
].map(item => ({titleProps: {smMinHeight: 58}, ...item}));


const StudentsSection = props => {
  return (
    <Container {...props}>
      <H3>{props.title}</H3>

      <Cols
        items={ITEMS}
      />
    </Container>
  )
}

StudentsSection.defaultProps = {
  title: 'Pourquoi donner des cours particuliers avec Clevermate ?\n',
};

export default StudentsSection;